var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.$store.state.LOADING)?_c('Spin',{attrs:{"fix":""}},[_c('img',{staticClass:"loading",attrs:{"src":require("./assets/logo.svg"),"alt":""}}),_c('div',[_vm._v("加载中...")])]):_vm._e(),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }